import { render, staticRenderFns } from "./DirectoryItem.vue?vue&type=template&id=3e24bda1&scoped=true&"
import script from "./DirectoryItem.vue?vue&type=script&lang=js&"
export * from "./DirectoryItem.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryItem.vue?vue&type=style&index=0&id=3e24bda1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e24bda1",
  null
  
)

export default component.exports